import { fetchWithAuth } from "./fetchHelpers";

export const LOGIE_API_ENDPOINT = "logie";
// "https://ubyneuzlhl.execute-api.eu-west-1.amazonaws.com/100";

/**
 * Fetches data from the LOGIE API using the provided URL and options.
 *
 * @async
 * @function fetchLogieData
 * @param {string} url - The endpoint path to append to the LOGIE API base URL.
 * @param {Object} [options] - Additional fetch options (e.g., method, body).
 * @returns {Promise<Object|null>} Resolves with the parsed JSON data from the response, or null if an error occurs.
 */
const fetchLogieApi = (url, options) => {
  return fetchWithAuth(`${LOGIE_API_ENDPOINT}/${url}`, options);
};

export const fetchWarehouseAggregate = async (body) => {
  try {
    const response = await fetchLogieApi("whAggregate", {
      method: "POST",
      body: JSON.stringify(body),
    });
    if (!response.ok) {
      throw new Error("Network response was not ok");
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching LOGIE data:", error);
    return null;
  }
};

export const fetchTranslations = async (params, options) => {
  const api_url = `getTranslation?` + params;

  return fetchLogieApi(api_url, {
    method: "GET",
    ...options,
    headers: {
      ...options.headers,
      "Content-Type": "application/json",
    },
  });
};

export const fetchLabelPositions = async (api_url, options) => {
  return fetchLogieApi(api_url, {
    method: "GET",
    ...options,
    headers: {
      ...options.headers,
      "Content-Type": "application/json",
    },
  });
};
